import { usePageData } from '@/hooks/usePageData'
import type { OrderHistoryPagePayload } from '@/types/ecommerce'

/*
  Order History — requires authentication. The Liquid wrapper redirects to
  /sign-in for guests, so by the time we render here the orders list is
  already scoped to the current user.

  Styling lives in src/styles/pages/order-history.css.
*/

function formatDate(iso: string | null): string {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleDateString('en-AU', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return iso
  }
}

export default function OrderHistory() {
  const payload = usePageData<OrderHistoryPagePayload>() ?? { orders: [], user_uuid: '' }
  const orders = payload.orders ?? []

  return (
    <section className="mig-order-history-section">
      <h1 className="mig-order-history-title">Order History</h1>

      {orders.length === 0 ? (
        <p className="mig-order-history-empty">
          You don't have any orders yet. <a href="/marketplace">Browse the Marketplace</a>.
        </p>
      ) : (
        <table className="mig-order-history-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Date</th>
              <th>Status</th>
              <th data-align="right">Total</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.uuid}>
                <td>{o.order_reference ?? o.uuid.slice(0, 8)}</td>
                <td>{formatDate(o.date_time)}</td>
                <td>{o.order_status ?? '—'}</td>
                <td data-align="right">${(o.order_total ?? 0).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  )
}
